import { Component, Inject, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from "moment";
import { NotifierService } from "../../shared/notifier/notifier.service";
import * as FileSaver from "file-saver";
import { DateAdapter, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { PieceService } from "../../services/piece.service";
import { ClientService } from "../../services/client.service";
import { BillingService } from '../../services/billing.service';

@Component({
  selector: 'app-report-full-piece-ot-dialog',
  templateUrl: "./report-full-piece-ot-dialog.component.html",
  styleUrls: ["./report-full-piece-ot-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [PieceService, ClientService, BillingService],
})
export class ReportFullPieceOtDialogComponent implements OnInit {

  listaIdOTs: number[] = [];
  fechaInicio: any;
  fechaFinal: any;

  constructor(
    public dialogRef: MatDialogRef<ReportFullPieceOtDialogComponent>,
    private notifierService: NotifierService,
    private pieceService: PieceService,
    private billingService: BillingService,
    private clientService: ClientService,
    private zone: NgZone,
    @Inject(MAT_DIALOG_DATA) public injected: any,
    private dateAdapter: DateAdapter<Date>
  ) { 
    this.dateAdapter.setLocale("es-PE");
    this.listaIdOTs = this.injected ? [...this.injected.arrIdOts] : [];
  }

  ngOnInit() {
  }
  generarReporteExcelFullInfoPorOT() {

    if (this.listaIdOTs.length == 0) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Se requiere seleccionar al menos una OT",
        type: 'error',
        duration: 5000
      });
      return;
    }

    let fechaInicio: string | undefined = undefined;
    let fechaFinal: string | undefined = undefined;

    if (!this.fechaInicio && this.fechaFinal) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar la fecha inicial",
        type: 'error',
        duration: 5000
      });
      return;
    }

    if (this.fechaInicio && !this.fechaFinal) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar la fecha final",
        type: 'error',
        duration: 5000
      });
      return;
    }

    if (!(this.fechaInicio && this.fechaFinal)) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar ambas fechas",
        type: 'error',
        duration: 5000
      });
      return;
    }

    this.notifierService.systemNotify({
      title: "Descargando",
      message: "Descargando reporte de piezas excel",
      type: "info",
    });

    fechaInicio = moment(this.fechaInicio).format("YYYY-MM-DD");
    fechaFinal = moment(this.fechaFinal).format("YYYY-MM-DD");

    this.billingService.exportarPiezasXls(this.listaIdOTs, fechaInicio , fechaFinal).subscribe(
      (result: any) => {
        const filename = 'ReporteInformativoPiezasOT.xlsx';
        FileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha descargado el Excel.',
          type: 'success'
        });
      },
      (error) => {
        console.log(error, "ERROR");

        let message = "Ha ocurrido un error al descargar el Excel";

        if (error.data) {
          if (error.data.message) {
            message = error.data.message;
          }
        }

        this.notifierService.systemNotify({
          title: 'Error',
          message: message || '',
          type: 'error',
          duration: 5000
        });
      }
    );
  }


  generarReportePDFFullInfoPorOT() {

    if (this.listaIdOTs.length == 0) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Se requiere seleccionar al menos una OT",
        type: 'error',
        duration: 5000
      });
      return;
    }

    let fechaInicio: string | undefined = undefined;
    let fechaFinal: string | undefined = undefined;

    if (!this.fechaInicio && this.fechaFinal) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar la fecha inicial",
        type: 'error',
        duration: 5000
      });
      return;
    }

    if (this.fechaInicio && !this.fechaFinal) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar la fecha final",
        type: 'error',
        duration: 5000
      });
      return;
    }

    if (!(this.fechaInicio && this.fechaFinal)) {
      this.notifierService.systemNotify({
        title: 'Error',
        message: "Es obligatorio seleccionar ambas fechas",
        type: 'error',
        duration: 5000
      });
      return;
    }

    this.notifierService.systemNotify({
      title: "Descargando",
      message: "Descargando reporte de piezas",
      type: "info",
    });

    fechaInicio = moment(this.fechaInicio).format("YYYY-MM-DD");
    fechaFinal = moment(this.fechaFinal).format("YYYY-MM-DD");

    this.billingService.exportarPiezas(this.listaIdOTs, fechaInicio , fechaFinal).subscribe(
      (result: any) => {
        const filename = 'ReporteInformativoPiezasOT.pdf';
        FileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha descargado el PDF.',
          type: 'success'
        });
      },
      (error) => {
        console.log(error, "ERROR");

        let message = "Ha ocurrido un error al descargar el PDF";

        if (error.data) {
          if (error.data.message) {
            message = error.data.message;
          }
        }

        this.notifierService.systemNotify({
          title: 'Error',
          message: message || '',
          type: 'error',
          duration: 5000
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/system/work-order/report-full-piece-ot-dialog/report-full-piece-ot-dialog.component.ts